import React from 'react';
import PropTypes from 'prop-types';
import { Avatar, Box, Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

import avatar2 from '../../../assets/images/avatars/avatar2.jpg';
import { divideBy } from '../../../styles/styleUtils';

const sidebarUserboxStyles = makeStyles((theme) => {
    return {
        appSidebarUserbox: (props) => {
            const { sidebarToggle } = props;
            return {
                background: theme.palette.grey[200],
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                padding: theme.themeVars.spacer,
                margin: '0',
                borderRadius: '0',
                textAlign: 'center',
                whiteSpace: 'nowrap',
                ...(sidebarToggle
                    ? {
                          paddingLeft: theme.themeVars.spacer,
                          paddingRight: theme.themeVars.spacer,
                          background: 'transparent'
                      }
                    : {})
            };
        },
        appSidebarUserboxDescription: {
            opacity: '.7',
            marginBottom: divideBy(theme.themeVars.spacer, 2)
        },
        appSidebarUserboxAvatar: (props) => {
            const { sidebarToggle } = props;
            return {
                width: '54px',
                height: '54px',
                marginLeft: 'auto',
                marginRight: 'auto',
                marginBottom: divideBy(theme.themeVars.spacer, 2),
                transition: theme.themeVars.transitionBase,
                ...(sidebarToggle
                    ? {
                          width: '34px',
                          height: '34px',
                          marginBottom: '0'
                      }
                    : {})
            };
        },
        appSidebarUserboxName: (props) => {
            const { sidebarToggle } = props;
            return {
                transition: theme.themeVars.transitionBase,
                opacity: '1',
                height: 'auto',
                whiteSpace: 'nowrap',
                ...(sidebarToggle
                    ? {
                          opacity: '0',
                          height: '0'
                      }
                    : {})
            };
        },
        appSidebarUserboxBtn: (props) => {
            const { sidebarToggle } = props;
            return {
                position: 'absolute',
                right: theme.themeVars.spacer,
                top: theme.themeVars.spacer,
                ...(sidebarToggle
                    ? {
                          opacity: '0'
                      }
                    : {})
            };
        },
        appSidebarUserboxBtnProfile: (props) => {
            const { sidebarToggle } = props;
            return {
                opacity: 1,
                visibility: 'visible',
                transition: theme.themeVars.transitionBase,
                ...(sidebarToggle
                    ? {
                          opacity: '0',
                          visibility: 'hidden'
                      }
                    : {})
            };
        }
    };
});
const SidebarUserbox = (props) => {
    const { sidebarToggle } = props;
    const classes = sidebarUserboxStyles({ sidebarToggle });

    return (
        <Box className={classes.appSidebarUserbox}>
            <Avatar alt="Remy Sharp" src={avatar2} className={classes.appSidebarUserboxAvatar} />
            <Box className={classes.appSidebarUserboxName}>
                <Box>
                    <b>Emma Taylor</b>
                </Box>
                <Box className={classes.appSidebarUserboxDescription}>Senior Web Developer</Box>
                <Box className={classes.appSidebarUserboxBtnProfile}>
                    <Button size="small" color="secondary" variant="contained" href="/pagesProfile">
                        View profile
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};

SidebarUserbox.propTypes = {
    sidebarToggle: PropTypes.bool.isRequired
};

export default SidebarUserbox;
